import React from 'react';

const BANNER_URL =
    'https://recommendations.asunnot.oikotie.fi/tori-aurora-search-page.html';

type OikotieBannerProps = {
    className?: string;
};

export function OikotieBanner(props: OikotieBannerProps) {
    const { className } = props;

    const [shouldRenderIframe, setShouldRenderIframe] = React.useState(true);

    const handleIframeError = () => {
        setShouldRenderIframe(false);
    };

    return shouldRenderIframe ? (
        <iframe
            src={BANNER_URL}
            className={className}
            width="100%"
            height="400"
            onError={handleIframeError}
            title="Oikotie advertisement"
        />
    ) : null;
}
